import React, { Fragment, useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { useToggle } from 'site-modules/shared/hooks/use-toggle';
// Components
import { StyleDataWrapper } from 'site-modules/comparator/components/style-data-wrapper/style-data-wrapper';
import { OtherStylesFeatureModal } from 'site-modules/comparator/components/other-styles-feature-modal/other-styles-feature-modal';

import './available-on-other-styles.scss';

export function AvailableOnOtherStyles({ name, style, featureNameSlug, featureCategorySlug, className, addVehicle }) {
  const [isModalOpened, toggleModalOpened] = useToggle();

  const handleAddVehicle = useCallback(
    styleId => {
      addVehicle({
        name: style.name,
        styleId,
      });
    },
    [addVehicle, style.name]
  );

  return (
    <Fragment>
      <button
        className={classnames('other-styles-btn text-gray-darker text-start p-0 border-0', className)}
        onClick={toggleModalOpened}
        data-tracking-id="comparator_view_other_styles"
        data-tracking-value={name}
      >
        <span className="feature-field-value">
          <u>Available on other styles</u> <span className="icon-info small" aria-hidden />
        </span>
      </button>
      <StyleDataWrapper styleId={style.styleId}>
        <OtherStylesFeatureModal
          styleId={style.styleId}
          featureName={name}
          featureNameSlug={featureNameSlug}
          featureCategorySlug={featureCategorySlug}
          addVehicle={handleAddVehicle}
          toggleModal={toggleModalOpened}
          isModalOpened={isModalOpened}
        />
      </StyleDataWrapper>
    </Fragment>
  );
}

AvailableOnOtherStyles.propTypes = {
  name: PropTypes.string.isRequired,
  featureCategorySlug: PropTypes.string.isRequired,
  featureNameSlug: PropTypes.string.isRequired,
  addVehicle: PropTypes.func.isRequired,
  style: PropTypes.shape({
    name: PropTypes.string,
    styleId: PropTypes.string,
  }).isRequired,
  className: PropTypes.string,
};

AvailableOnOtherStyles.defaultProps = {
  className: null,
};
